'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/SalesforceCampaigns';
const INIT_STATE = {
  campaigns: [],
  sfdcSyncEnabled: false,
  requestState: RequestState.NOT_REQUESTED,
  requestStateSettings: RequestState.NOT_REQUESTED
};
export function salesforceCampaigns(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_CAMPAIGNS:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_CAMPAIGNS:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_CAMPAIGNS:
      return Object.assign({}, state, {
        campaigns: action.campaigns
      });
    case Actions.FAIL_GETTING_CAMPAIGNS:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED
      });
    case Actions.REQUEST_SFDC_SETTINGS:
      return Object.assign({}, state, {
        requestStateSettings: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_SFDC_SETTINGS:
      return Object.assign({}, state, {
        requestStateSettings: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_SFDC_SETTINGS:
      return Object.assign({}, state, {
        sfdcSyncEnabled: !!action.settings.syncEnabled
      });
    case Actions.FAIL_GETTING_SFDC_SETTINGS:
      return Object.assign({}, state, {
        requestStateSettings: RequestState.FAILED
      });
    default:
      return state;
  }
}